import React from "react";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { Avatar, Box, Divider, Typography } from "@material-ui/core";
import { CustomCard } from "../../../../../../../../Components";
import { getDownloadableLink } from "../../../../../../../../Helper";

// icons
import { Image01Icon } from "../../../../../../../../assets/icons";

// styles
import useStyles from "./styles";

function LocationImageCard({ data }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();

  return (
    <CustomCard
      borderRadius="md"
      borderColor="secondary"
      classes={styles.containerPropertyCard}
    >
      <Box className={styles.containerHeaderCard}>
        <img
          alt="Avatar"
          src={getDownloadableLink(data?.image?.result?.[0]?.fileId) || ""}
          className={styles.contaierImageProprety}
        />
      </Box>
      <Box className={styles.containerBodyCard}>
        <Box className={styles.sectionMnueCategoryName}>
          <Typography className={styles.containerCategoryName}>
            {data?.categoryName}
          </Typography>
        </Box>
        <Box className={styles.sectionCreatedBy}>
          <Box className={styles.containerItemAvatar}>
            <Avatar
              className={styles.AvatarStyle}
              src={"/images/contacts/MaleAvatar.svg"}
            ></Avatar>
          </Box>
          <Box className={styles.containerCreatedBy}>
            <Typography className={styles.createdByValue}>
              {data?.createdBy}
            </Typography>
            <Typography className={styles.createdByTitle}>
              {translate("Created-by")}
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box className={styles.containerInfoProprety}>
          <Box className={styles.containerCountImages}>
            <Image01Icon
              width="20"
              height="20"
              fill={palette.utility.utility_gray_400}
            />
            <Typography className={styles.totalCountValue}>
              {data?.image?.totalCount}
            </Typography>
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
}

export default LocationImageCard;
